import { Link } from 'react-router-dom';
import { ChipInfo } from './ChipInfo';
import { docsToReviewHelp } from './chipHelp';
import styles from './ScorecardStrip.module.css';

const LABEL = 'Docs to review';

/** Count of uploaded shipment documents waiting for ops review; always links to the queue. */
export function DocsToReviewChip({ count }: { count?: number }) {
  const warning = count != null && count > 0;
  return (
    <span className={styles.chipWithInfo}>
      <Link
        className={`${styles.chip} ${warning ? styles.chipWarning : ''}`}
        to="/documents?status=UPLOADED"
      >
        <span>{LABEL}</span>
        <span className={styles.chipBadge}>{count ?? '—'}</span>
        <span aria-hidden="true">→</span>
      </Link>
      <ChipInfo label={LABEL} text={docsToReviewHelp} />
    </span>
  );
}
